// extracted by mini-css-extract-plugin
export default {"container":"Mentor_container__ipRnf","body":"Mentor_body__LyCv4","content":"Mentor_content__81oLG","back":"Mentor_back__DtKt8"};